export const stats = [
    {
        title: "Total Bookings",
        value: "1,245",
        sub: "450 Hotels, 795 Flights",
        icon: "pi pi-ticket", // PrimeIcon class
        color: "!bg-blue-600",
        trend: "+12.5%",
        trendColor: "text-green-500"
    },
    {
        title: "Today's Revenue",
        value: "$12,450",
        sub: "vs $10,200 yesterday",
        icon: "pi pi-dollar",
        color: "!bg-emerald-500",
        trend: "+8.2%",
        trendColor: "text-green-500"
    },
    {
        title: "Weekly Revenue",
        value: "$84,320",
        sub: "Current financial week",
        icon: "pi pi-chart-line",
        color: "!bg-violet-600",
        trend: "-2.4%",
        trendColor: "text-red-500"
    },
    {
        title: "Pending Approvals",
        value: "18",
        sub: "Requires immediate attention",
        icon: "pi pi-clock",
        color: "!bg-amber-500",
        trend: "Urgent",
        trendColor: "text-amber-600"
    },
];

export const pendingApprovals = [
    { id: 1, type: "Flight", user: "Sarah Connor", amount: "$450", status: "Pending", time: "10 mins ago" },
    { id: 2, type: "Hotel", user: "John Wick", amount: "$1,200", status: "Pending", time: "25 mins ago" },
    { id: 3, type: "Flight", user: "Ellen Ripley", amount: "$320", status: "Pending", time: "1 hour ago" },
    { id: 4, type: "Hotel", user: "Tony Stark", amount: "$5,000", status: "Pending", time: "2 hours ago" },
];

export const activities = [
    { id: 1, text: "New booking received from Miami", time: "5 min ago", type: "success" },
    { id: 2, text: "System maintenance scheduled", time: "20 min ago", type: "warning" },
    { id: 3, text: "Refund processed for #BK-9921", time: "1 hour ago", type: "neutral" },
    { id: 4, text: "Server load peaked at 85%", time: "3 hours ago", type: "danger" },
];